import styled from "styled-components";
import {ACTIVE} from "../../../../../themes/css-global-classes";

export const FiltersMobileButtonDefaultBox = styled.a`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 3.4rem;
    height: 3.4rem;
    border: 1px solid ${props => props.theme.colors.boxBorderContrast};
    border-radius: 50%;
    margin: 0 0.5rem;

    &.${ACTIVE} {
      &:after {
        content: "";
        position: absolute;
        top: -0.25rem;
        right: -0.25rem;
        width: 1rem;
        height: 1rem;
        background: ${props => props.theme.colors.danger};
        border-radius: 50%;
      }
    }

`;